module.exports = __webpack_public_path__ + "img/PE.80d429c5.png";